import { Clock, MessagesSquare, ShieldCheck, Wallet } from 'lucide-react';

/**
 * Discussão técnica é o recurso que mais precisa de explicação: é o único que
 * envolve outra pessoa do outro lado e o único que **consome unidades**.
 *
 * O custo aparece aqui, na landing, e não só no momento de abrir a discussão.
 * Descobrir que a ação era paga depois de clicar é a forma mais rápida de
 * queimar a confiança no produto.
 */
export function SecaoAssessoria() {
  const pontos = [
    {
      icone: MessagesSquare,
      titulo: 'Conversa vinculada ao paciente',
      texto: 'A discussão permanece conectada ao histórico e aos exames, facilitando a análise e as consultas futuras.',
    },
    {
      icone: Clock,
      titulo: 'Em tempo real',
      texto: 'Acompanhe a conversa pela plataforma e consulte as mensagens sempre que precisar. O conteúdo permanece salvo no histórico do caso.',
    },
    {
      icone: Wallet,
      titulo: 'Cobrança por uso',
      texto: 'Cada discussão aberta consome unidades do seu saldo. Sem mensalidade para isso.',
    },
    {
      icone: ShieldCheck,
      titulo: 'Suporte, não substituição',
      texto: 'A assessoria apoia o raciocínio clínico. Quem decide e assina é você.',
    },
  ];

  return (
    <section id="assessoria" className="scroll-mt-20 border-b border-border bg-background py-20">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2">
        <div>
          <p className="text-sm font-semibold uppercase tracking-wider text-accent">
            Discussões técnicas
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Um segundo olhar, com todo o caso em contexto.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
            Abra uma discussão com um especialista diretamente no prontuário do paciente. Histórico, exames e evolução seguem juntos, para que você não precise reunir ou reescrever todas as informações.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {pontos.map((ponto) => (
            <div key={ponto.titulo} className="rounded-xl border border-border bg-card p-5">
              <ponto.icone className="h-5 w-5 text-accent" />
              <h3 className="mt-3 text-sm font-semibold text-card-foreground">{ponto.titulo}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{ponto.texto}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
